import {
    CountryStateState,
    Country,
    State,
} from '../.././../src/Definitions/CountryState';
import { select } from '@wordpress/data';
import { STORE_NAME } from './constants';

export const selectors = {
    getCountries( state: CountryStateState ): Country[] {
        return Object.values( state.countries );
    },

    getCountry(
        state: CountryStateState,
        countryCode: string
    ): Country | null {
        const countries = state.countries[ countryCode ] || null;
        if ( ! countries ) {
            select( STORE_NAME ).getCountries();
        }

        return countries;
    },

    getCountryStates( state: CountryStateState, countryCode: string ): State[] {
        return state.countries[ countryCode ]?.states || [];
    },

    getStateItem(
        state: CountryStateState,
        countryCode: string,
        stateCode: string
    ): State | null {
        const states = state.countries[ countryCode ]?.states || [];
        const stateItem =
            states.find( ( stateData ) => stateData.code === stateCode ) ||
            null;
        if ( ! stateItem ) {
            select( STORE_NAME ).getCountryStates( countryCode );
        }
        return stateItem;
    },

    isLoading( state: CountryStateState, selector: string ): boolean {
        return !! state.isLoading[ selector ];
    },

    getError( state: CountryStateState, selector: string ): string | null {
        return state.errors[ selector ] || null;
    },

    getCountryStateOptions( state: CountryStateState ) {
        const countries = Object.values( state.countries );

        return {
            countryOptions: countries.map( ( country ) => ( {
                value: country.code,
                label: country.name,
            } ) ),

            getStatesForCountry: ( countryCode: string ) => {
                const country = state.countries[ countryCode ];
                return (
                    country?.states.map( ( state ) => ( {
                        value: state.code,
                        label: state.name,
                    } ) ) || []
                );
            },
        };
    },
};
